import styled from 'styled-components/macro';
import * as DropDownMenu from '@radix-ui/react-dropdown-menu';

export const Wrapper = styled(DropDownMenu.Label)``;
